<template>
    <tbody style="position: relative;" v-bind:class="{'tx-table__td-no-top-border': actionDetails?.action?.type === 'dex:liquidity_asset_2'}">
        <tr class="new-row-animation">
            <td>
                <div class="tx-table__cell">
                    <div class="tx-overview-action-type">
                        <div class="tx-overview-action-type__icon">
                            <event-overview-icon
                                v-bind:event="eventName"
                            />
                        </div>
                        {{ $t(`events.${eventName}`) }}
                    </div>
                </div>
            </td>
            <td>
                <div class="tx-table__cell">
                    <template v-if="type === 'jetton_swap' || type === 'nft_transfer' || type === 'jetton_transfer' || type === 'jetton_mint'">
                        <!-- Exception for nft purchase event, when sender is undefined -->
                        <template
                            v-if="eventName === 'nft_purchase' && !processedAddressesFrom && actionDetails?.meta?.marketplace">
                            <ui-address v-if="actionDetails.meta.marketplace === 'fragment'" address="UQBAjaOyi2wGWlk-EDkSabqqnF-MrrwMadnwqrurKpkla4QB" />
                            <span style="text-transform: capitalize" v-else>{{ actionDetails.meta.marketplace }}</span>
                        </template>
                        <ui-address
                            v-else
                            v-bind:class="{ 'ui-address-event-overview': event }"
                            v-bind:address="processedAddressesFrom"
                            v-bind:alias="actionDetails.source_alias"
                        />
                        <div class="tx-table-action-icon">
                            <arrow-right />
                        </div>
                        <ui-address
                            v-bind:class="{ 'ui-address-event-overview': event }"
                            class="ui-address-event-overview"
                            v-bind:address="processedAddressesTo"
                            v-bind:alias="actionDetails.destination_alias"
                        />
                    </template>
                    <template v-else-if="type === 'nft_mint'">
                        <ui-address
                            v-bind:class="{ 'ui-address-event-overview': event }"
                            v-bind:address="processedAddressesFrom"
                            v-bind:alias="actionDetails.source_alias"
                        />
                    </template>
                    <template v-else-if="type === 'contract_deploy'">
                        <ui-address
                            v-bind:class="{ 'ui-address-event-overview': event }"
                            v-bind:address="processedAddressesTo"
                            v-bind:alias="actionDetails.destination_alias"
                        />
                    </template>
                    <template v-else>
                        <ui-address
                            v-bind:class="{ 'ui-address-event-overview': event || type === 'ton_transfer' }"
                            v-bind:address="processedAddressesFrom"
                            v-bind:alias="actionDetails.source_alias"
                        />
                        <div class="tx-table-action-icon" v-if="event || type === 'ton_transfer'">
                            <arrow-right />
                        </div>
                        <ui-address v-if="event || type === 'ton_transfer'"
                            v-bind:class="{ 'ui-address-event-overview': event || type === 'ton_transfer' }"
                            v-bind:address="processedAddressesTo"
                            v-bind:alias="actionDetails.destination_alias"
                        />
                    </template>
                </div>
            </td>

            <td>
                <div class="tx-table__cell tx-table-payload">
                    <template v-if="type === 'call_contract'">
                        <span class="tx-table-payload-text muted">{{ actionDetails?.op }}</span>
                    </template>

                    <template v-else-if="type === 'contract_deploy'">
                        <span class="tx-table-payload-text muted">{{ actionDetails?.op }}</span>
                    </template>

                    <template v-else-if="['jetton_transfer', 'nft_transfer', 'ton_transfer'].includes(type)">
                        <span v-if="actionDetails?.encrypted" class="muted">{{ $t('tx.encrypted_message') }}</span>
                        <span class="tx-table-payload-text">{{ actionDetails?.message }}</span>
                    </template>

                    <template v-else-if="actionDetails?.meta?.provider">
                        <span class="tx-table-payload-text muted" style="text-transform: capitalize">Provider: {{ actionDetails.meta.provider }}</span>
                    </template>

                    <template v-else-if="actionDetails?.dex">
                        <span class="tx-table-payload-text muted" style="text-transform: capitalize">DEX: {{ actionDetails.dex }}</span>
                    </template>
                </div>
            </td>

            <td class="column-wide">
                <div class="tx-table__cell tx-table__cell--align-right">
                    <event-overview-badge
                        v-bind:type="type"
                        v-bind:actionDetails="actionDetails"
                    />
                </div>
            </td>
        </tr>
    </tbody>
</template>

<script>
import ArrowRight from '@img/icons/tonscan/arrow-small-right.svg?vue';
import EventOverviewBadge from './EventOverviewBadge.vue';
import EventOverviewIcon from './EventOverviewIcon.vue';

export default {
    props: {
        action: Object,
        actionDetails: Object,
        type: String,
        event: Boolean,
    },

    computed: {
        eventName() {
            // Sometimes default type must be changed to generated message action name
            const exceptions = ['nft_purchase', 'jetton_burn'];

            return this.actionDetails?.event && exceptions.includes(this.actionDetails.event)
                ? this.actionDetails.event
                : this.type;
        },

        processedAddressesFrom() {
            return this.actionDetails.from;
        },

        processedAddressesTo() {
            return this.actionDetails.to;
        },
    },

    components: {
        ArrowRight,
        EventOverviewBadge,
        EventOverviewIcon,
    },
};
</script>

<style lang="scss">
.tx-table-address-route {
    display: flex;
    align-items: center;
}

.tx-table-payload-text {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

.ui-address-event-overview {
    max-width: 180px;
}
@media (max-width: 599px) {
    .tx-table-action-icon {
        margin: 0 5px;
    }
}
.tx-table__td-no-top-border td,
.tx-table__td-no-top-border .tx-mobile-content{
    border-top: none!important;
}
</style>
